import React, { useEffect } from "react";
import { IoCloseCircleOutline } from "react-icons/io5";
import { FiPhone, FiMail, FiClock, FiShield, FiUsers, FiZap } from "react-icons/fi";
import ContactSupportForm from "../screens/Forms/ContactSupport"; // adjust path

const EnquiryDialog = ({ open, onClose, t }) => {
  useEffect(() => {
    const handleKey = (e) => { if (e.key === "Escape") onClose(); };
    if (open) document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [open, onClose]);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  if (!open) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.55)",
        zIndex: 1300,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "1rem",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          borderRadius: 16,
          width: "100%",
          maxWidth: 640,
          maxHeight: "92vh",
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* ── Left Panel (top on mobile, full-width accent bar) ── */}
        <div
          style={{
            background: "#7a0024",
            padding: "1.8rem 2rem",
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            borderRadius: "16px 16px 0 0",
          }}
        >
          {/* Brand tag */}
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              background: "rgba(255,255,255,0.12)",
              border: "1px solid rgba(255,255,255,0.2)",
              borderRadius: 4,
              padding: "4px 10px",
              fontSize: 10,
              fontWeight: 700,
              color: "rgba(255,255,255,0.9)",
              textTransform: "uppercase",
              letterSpacing: "1px",
              width: "fit-content",
            }}
          >
            <FiZap size={11} />
            {t("Free demo available")}
          </span>

          {/* Title + sub */}
          <div>
            <div
              style={{
                width: 36,
                height: 3,
                background: "rgba(255,255,255,0.3)",
                borderRadius: 2,
                marginBottom: 10,
              }}
            />
            <div style={{ fontSize: "1.25rem", fontWeight: 800, color: "#fff", lineHeight: 1.25 }}>
              {t("Let's talk about your business")}
            </div>
            <div style={{ fontSize: "12px", color: "rgba(255,255,255,0.65)", marginTop: 6, lineHeight: 1.6 }}>
              {t("Have questions or want a personalised walkthrough? Drop your details and our team will reach out within 2 hours.")}
            </div>
          </div>

          {/* Contact info */}
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 12, color: "rgba(255,255,255,0.85)" }}>
              <FiPhone size={14} style={{ color: "rgba(255,255,255,0.5)", flexShrink: 0 }} />
              7305888112 / 7305888114
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 12, color: "rgba(255,255,255,0.85)" }}>
              <FiMail size={14} style={{ color: "rgba(255,255,255,0.5)", flexShrink: 0 }} />
              <a href="mailto:support@yuukke.com" style={{ color: "#ffb3c6", textDecoration: "none", fontWeight: 600 }}>
                support@yuukke.com
              </a>
            </div>
          </div>

          {/* Trust bar */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 16,
              paddingTop: 12,
              borderTop: "1px solid rgba(255,255,255,0.12)",
              flexWrap: "wrap",
            }}
          >
            {[
              { icon: <FiClock size={12} />, label: t("2hr response") },
              { icon: <FiShield size={12} />, label: t("No spam") },
              { icon: <FiUsers size={12} />, label: t("5000+ providers") },
            ].map(({ icon, label }) => (
              <div key={label} style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 11, color: "rgba(255,255,255,0.55)" }}>
                {icon} {label}
              </div>
            ))}
          </div>
        </div>

        {/* ── Right Panel (form) ── */}
        <div style={{ padding: "1.6rem 2rem", position: "relative" }}>
          {/* Form header */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "1.2rem" }}>
            <div>
              <div style={{ fontSize: 15, fontWeight: 700, color: "#1a1a1a" }}>
                {t("Send an Enquiry")}
              </div>
              <div style={{ fontSize: 12, color: "#888", marginTop: 2 }}>
                {t("All fields are required")}
              </div>
            </div>
            <IoCloseCircleOutline
              onClick={onClose}
              style={{ color: "#999", fontSize: 26, cursor: "pointer", flexShrink: 0 }}
            />
          </div>

          {/* Form */}
          <ContactSupportForm versionV2={true} closeModel={onClose} />
        </div>
      </div>
    </div>
  );
};

export default EnquiryDialog;